// @ah/podcasts shared GraphQL queries — used by desktop and mobile.

export const RECOMMENDED_EPISODES_QUERY = /* GraphQL */ `
  query RecommendedEpisodes {
    recommendedEpisodes(limit: 20) {
      id
      name
      description
      imageUrl
      duration
      datePublished
      summaryGeneratedAt
      summary {
        hook
        whatItsAbout
        topics
      }
      series {
        id
        name
        imageUrl
      }
    }
  }
`;

export const PODCAST_EPISODES_QUERY = /* GraphQL */ `
  query PodcastsList {
    podcastEpisodes(limit: 30) {
      id
      name
      description
      imageUrl
      duration
      datePublished
      summaryGeneratedAt
      summary {
        hook
        whatItsAbout
        topics
      }
      series {
        id
        name
        imageUrl
      }
    }
  }
`;

export const PODCAST_SERIES_LIST_QUERY = /* GraphQL */ `
  query PodcastSeriesList {
    podcastSeriesList(limit: 60) {
      id
      name
      author
      description
      imageUrl
      popularityRankGlobal
      totalEpisodesCount
      genres
    }
  }
`;

export const PODCAST_SERIES_DETAIL_QUERY = /* GraphQL */ `
  query PodcastSeries($id: ID!) {
    podcastSeriesById(id: $id) {
      id
      name
      description
      author
      imageUrl
      websiteUrl
      language
      genres
      totalEpisodesCount
      popularityRankGlobal
      latestEpisodes(limit: 30) {
        id
        name
        description
        imageUrl
        duration
        datePublished
        summaryGeneratedAt
      }
    }
  }
`;

const EPISODE_LIST_FIELDS = /* GraphQL */ `
  id
  name
  description
  imageUrl
  duration
  datePublished
  summaryGeneratedAt
  summary { hook whatItsAbout topics }
  series { id name imageUrl }
`;

export const RECENTLY_HEARD_EPISODES_QUERY = /* GraphQL */ `
  query RecentlyHeardEpisodes($limit: Int) {
    recentlyHeardEpisodes(limit: $limit) { ${EPISODE_LIST_FIELDS} }
  }
`;

export const SAVED_EPISODES_QUERY = /* GraphQL */ `
  query SavedEpisodes($limit: Int) {
    savedEpisodes(limit: $limit) { ${EPISODE_LIST_FIELDS} }
  }
`;

export const RECORD_EPISODE_ENGAGEMENT_MUTATION = /* GraphQL */ `
  mutation RecordEpisodeEngagement($id: ID!) {
    recordEpisodeEngagement(id: $id)
  }
`;

export const RECORD_EPISODE_SAVE_MUTATION = /* GraphQL */ `
  mutation RecordEpisodeSave($id: ID!) {
    recordEpisodeSave(id: $id)
  }
`;

export const RECORD_EPISODE_UNSAVE_MUTATION = /* GraphQL */ `
  mutation RecordEpisodeUnsave($id: ID!) {
    recordEpisodeUnsave(id: $id)
  }
`;

export const PODCAST_EPISODE_DETAIL_QUERY = /* GraphQL */ `
  query PodcastEpisode($id: ID!) {
    podcastEpisode(id: $id) {
      id
      name
      description
      audioUrl
      imageUrl
      duration
      datePublished
      episodeNumber
      seasonNumber
      transcriptionStatus
      summaryStatus
      summaryGeneratedAt
      summary {
        hook
        whatItsAbout
        eli5
        longRead
        keyQuotes { quote speaker timestampSec }
        keyIdeas { title body }
        keyPeople { name role }
        whyItMatters
        chapters { title startSec body }
        topics
      }
      series {
        id
        name
        author
        imageUrl
      }
      isSaved
    }
  }
`;
